var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyerCharges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.49 22.5433C22.7115 24.3659 20.4455 25.6071 17.9786 26.1099C15.5117 26.6128 12.9546 26.3547 10.6309 25.3683C8.30708 24.382 6.32092 22.7116 4.92352 20.5684C3.52613 18.4253 2.78027 15.9057 2.78027 13.3281C2.78027 10.7506 3.52613 8.23095 4.92352 6.08781C6.32091 3.94467 8.30708 2.2743 10.6309 1.28792C12.9546 0.30154 15.5117 0.0434577 17.9786 0.546309C20.4455 1.04916 22.7115 2.29036 24.49 4.11295L21.8138 6.85547C20.5646 5.5753 18.9729 4.70349 17.2402 4.35029C15.5075 3.99709 13.7114 4.17837 12.0792 4.87119C10.447 5.56401 9.05197 6.73727 8.07045 8.24259C7.08893 9.74791 6.56505 11.5177 6.56505 13.3281C6.56505 15.1386 7.08893 16.9083 8.07045 18.4137C9.05197 19.919 10.447 21.0922 12.0792 21.7851C13.7114 22.4779 15.5075 22.6592 17.2402 22.306C18.9729 21.9528 20.5646 21.081 21.8138 19.8008L24.49 22.5433Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.458008 9.51367L16.335 9.51397L15.4435 12.3695L0.45884 12.3694L0.458008 9.51367Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4598 14.6295H15.0589L14.2094 17.4853H0.460633L0.4598 14.6295Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyerCharges);
export default __webpack_public_path__ + "static/media/loyer_charges.3ba682c80c1a12f254242aab862281ee.svg";
export { ForwardRef as ReactComponent };